import {useEffect} from "react";
import {getPlayerInfo} from "../services/player";
import {getReferralNotifications, registerReferral} from "../services/referrals";
import BonusStore from "../store/bonus";
import {getReferralTokenFromLocation, onReferralTokenChanged} from "../utils/referralLaunch";

const REFERRAL_REGISTERED_KEY = "wordmania_referral_registered_token";

// useReferralEffects регистрирует запуск по ссылке и показывает уведомления о наградах.
export function useReferralEffects(showSuccessSnackbar) {
    useEffect(() => {
        const loadNotifications = () => {
            getReferralNotifications().then(resp => {
                const notifications = resp?.data?.response?.notifications || [];
                if (notifications.length === 0) {
                    return;
                }

                notifications.forEach(item => {
                    if (item?.message) {
                        showSuccessSnackbar(item.message);
                    }
                });

                getPlayerInfo().then(playerResp => {
                    const player = playerResp?.data?.response;
                    if (player?.coins !== undefined) {
                        BonusStore.setCoins(player.coins);
                    }
                }).catch(err => {
                    console.error("Failed to refresh player after referral notification:", err);
                });
            }).catch(err => {
                console.error("Failed to load referral notifications:", err);
            });
        };

        const registerToken = token => {
            const savedToken = localStorage.getItem(REFERRAL_REGISTERED_KEY);
            if (!token || savedToken === token) {
                return;
            }

            registerReferral(token).then(() => {
                localStorage.setItem(REFERRAL_REGISTERED_KEY, token);
                loadNotifications();
            }).catch(err => {
                console.error("Failed to register referral:", err);
                loadNotifications();
            });
        };

        registerToken(getReferralTokenFromLocation());
        const unsubscribe = onReferralTokenChanged(registerToken);
        loadNotifications();

        return unsubscribe;
    }, [showSuccessSnackbar]);
}
